import { Flex, Heading, Spinner, Text } from "@chakra-ui/react";
import { type ChainFullId, ChainFullIds, formatToNormalUnit } from "@umami/chains";
import { useGetNetworkSymbol } from "@umami/state";
import { useFormContext } from "react-hook-form";

import { useColor } from "../../styles/useColor";

export const SignPageFee = ({
  fee,
  chainId = ChainFullIds.TEZOS,
}: {
  fee: string | number;
  chainId?: ChainFullId;
}) => {
  const color = useColor();
  const symbol = useGetNetworkSymbol()(chainId);

  return (
    <Flex alignItems="center">
      <Heading marginRight="4px" color={color("700")} size="md">
        Fee:
      </Heading>
      <Text data-testid="fee">
        {formatToNormalUnit(fee, chainId)} <b>{symbol}</b>
      </Text>
    </Flex>
  );
};

export const AsyncSignPageFee = ({
  fee,
  chainId = ChainFullIds.TEZOS,
}: {
  fee: string | number;
  chainId?: ChainFullId;
}) => {
  const color = useColor();
  const form = useFormContext();
  const safeSendFeeLoading = form.watch("safeSendFeeLoading");
  const symbol = useGetNetworkSymbol()(chainId);

  return (
    <Flex alignItems="center">
      <Heading marginRight="4px" color={color("700")} size="md">
        Fee:
      </Heading>
      {safeSendFeeLoading ? (
        <Spinner size="sm" />
      ) : (
        <Text data-testid="fee">
          {formatToNormalUnit(fee, chainId)} <b>{symbol}</b>
        </Text>
      )}
    </Flex>
  );
};
